'use strict'

function hideAlerts() {
    $('[role="alert"]').hide();
}

function removeAlerts() {
    $('[role="alert"]').remove();
}

function checkElement(element, type, isHideAlerts) {
    //type = dropdown || combobox || datepicker || numeric || text, ...
    var isValid;
    if (isHideAlerts) {

        if (type === "datepicker") {
            //var currentLanguage = kendo.culture().name;
            isValid = $(element).kendoValidator({
                errorTemplate: "" /*,
                rules: {
                    customDateRule: function (input) {
                        var str = input.val();
                        function tstDate() {
                            var str2;

                            if (currentLanguage === "de-DE" ||
                                currentLanguage === "ru-RU") {
                                str2 = str.split(".");
                            } else if (currentLanguage === "pt-PT") {
                                str2 = str.split("-");
                            } else {
                                str2 = str.split("/");
                            }
                            if (str2.length != 3) {
                                return false;
                            }
                            if (currentLanguage === "ru-RU" ||
                                currentLanguage === "fr-FR" ||
                                currentLanguage === "es-ES") {
                                str2 = str2[2] + '-' + str2[1] + '-' + str2[0];// ru(1.1.2000), fr, es
                            } else if (
                                currentLanguage === "en-US" ||
                                currentLanguage === "de-DE") {
                                str2 = str2[2] + '-' + str2[0] + '-' + str2[1];// en, de(1.1.2000)
                            } else if (
                                currentLanguage === "pt-PT") {
                                str2 = str2[1] + '-' + str2[0] + '-' + str2[2];// por (1-1-2000)
                            }

                            if (new Date(str2) == 'Invalid Date') {
                                return false;
                            }
                            return str;
                        }

                        var S = tstDate();
                        if (S) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } */
            }).data("kendoValidator").validate();
        } else {
            isValid = $(element).kendoValidator({
                errorTemplate: ""
            }).data("kendoValidator").validate();
        }
    } else {
        isValid = $(element).kendoValidator().data("kendoValidator").validate();
    }
    var elemId = $(element).attr('id');
    if (isValid) {
        if (type === "dropdown") {
            $(element).siblings('.k-dropdown-wrap').removeClass('drop-invalid');
        } else if (type === "combobox") {
            $('[name="' + elemId + '_input"]').removeClass('input-invalid');
        } else if (type === "datepicker") {
            $(element).removeClass('date-invalid');
            $(element).parent().removeClass('date-invalid');
            $(element).siblings('.k-select').removeClass('date-invalid');
        } else if (type === 'numeric') {
            $(element).removeClass('input-invalid');
            $(element).siblings('.k-formatted-value').removeClass('input-invalid');
        } else if (type === 'multiselect') {
            $(element).siblings('.k-multiselect-wrap').removeClass('multi-invalid');
        } else {
            $(element).removeClass('input-invalid');
        }
        $('label[for="' + elemId + '"]').removeClass('label-invalid');
    } else {
        if (type === "dropdown") {
            $(element).siblings('.k-dropdown-wrap').addClass('drop-invalid');
        } else if (type === "combobox") {
            $('[name="' + elemId + '_input"]').addClass('input-invalid');
        } else if (type === "datepicker") {
            $(element).addClass('date-invalid');
            $(element).parent().addClass('date-invalid');
            $(element).siblings('.k-select').addClass('date-invalid');
        } else if (type === 'numeric') {
            $(element).addClass('input-invalid');
            $(element).siblings('.k-formatted-value').addClass('input-invalid');
        } else if (type === 'multiselect') {
            $(element).siblings('.k-multiselect-wrap').addClass('multi-invalid');
        } else {
            $(element).addClass('input-invalid');
        }
        $('label[for="' + elemId + '"]').addClass('label-invalid');
    }
    return isValid;
}

function checkNumericNull(element, isHideAlerts, grid){
    return $(element).kendoValidator({
        errorTemplate: '',
        rules: {
            customNumRule: function(input){
                var numValue;

                try{
                    numValue = $(input.siblings()[0]).data('kendoNumericTextBox').value();
                } catch (e) {
                    numValue = $(input).data('kendoNumericTextBox').value();
                }
                console.log('NUMVALUE::', numValue);
                if (numValue > 0){
                    $(element).removeClass('input-invalid');
                    $(element).siblings('.k-formatted-value').removeClass('input-invalid');
                    console.log('check numeric return true');
                    return true;
                } else {
                    $(element).addClass('input-invalid');
                    $(element).siblings('.k-formatted-value').addClass('input-invalid');
                    console.log('check numeric return false');
                    return false;
                }
            }
        }
    }).data("kendoValidator").validate();
}

function checkNumeric(element) {
    return $(element).kendoValidator({
        errorTemplate: '',
        rules: {
            customNumRule: function (input) {
                var numValue;

                try {
                    numValue = $(input.siblings()[0]).data('kendoNumericTextBox').value();
                } catch (e) {
                    numValue = $(input).data('kendoNumericTextBox').value();
                }
                console.log('NUMVALUE::', numValue);
                console.log($(element).attr('required'));
                if (numValue > 0 || (numValue === 0 && $(element).attr('required') === undefined)) {
                    $(element).removeClass('input-invalid');
                    $(element).siblings('.k-formatted-value').removeClass('input-invalid');
                    console.log('check numeric return true');
                    return true;
                } else {
                    $(element).addClass('input-invalid');
                    $(element).siblings('.k-formatted-value').addClass('input-invalid');
                    console.log('check numeric return false');
                    return false;
                }
            }
        }
    }).data("kendoValidator").validate();
}

function checkNumericNullCustom(element){
    var numValue = +$(element).val();
    var elemId = $(element).attr('id');

    if (numValue > 0) {
        $(element).removeClass('input-invalid');
        $(element).siblings('.k-formatted-value').removeClass('input-invalid');
        $('label[for="' + elemId + '"]').removeClass('label-invalid');
        return true;
    } else {
        $(element).addClass('input-invalid');
        $(element).siblings('.k-formatted-value').addClass('input-invalid');
        $('label[for="' + elemId + '"]').addClass('label-invalid');
        return false;
    }
}

function checkEmail(element, type, emailMessage, required) {
    var validator = $(element).kendoValidator({
        messages: {
            required: required,
            email: emailMessage
        }
    }).data("kendoValidator");
    validator.hideMessages();
    var isValid = validator.validate();
    var elemId = $(element).attr('id');
    if (isValid) {
        $(element).removeClass('input-invalid');
        $('label[for="' + elemId + '"]').removeClass('label-invalid');
    } else {
        $(element).addClass('input-invalid');
        $('label[for="' + elemId + '"]').addClass('label-invalid');
    }
    return isValid;
}

function setInvalidStyle() {
    $('[role="alert"]:visible').each(function (i, val) {
        var elemId = $(val).attr('data-for');
        var element = $('#' + elemId);
        if (element.attr('data-role') === 'combobox') {
            $('[name="' + elemId + '_input"]').addClass('input-invalid');
        } else if (element.attr('data-role') === 'dropdownlist') {
            element.siblings('.k-dropdown-wrap').addClass('drop-invalid');
        } else if (element.attr('data-role') === 'multiselect') {
            element.siblings('.k-multiselect-wrap').addClass('multi-invalid');
        } else {
            element.addClass('input-invalid');
        }
        $('label[for="' + elemId + '"]').addClass('label-invalid');
    });
}

function setInvalidStyleElement(element) {
    var elemId = element.id;
    if (element.attr('data-role') === 'combobox') {
        $('[name="' + elemId + '_input"]').addClass('input-invalid');
    } else if (element.attr('data-role') === 'dropdownlist') {
        element.siblings('.k-dropdown-wrap').addClass('drop-invalid');
    } else {
        element.addClass('input-invalid');
    }
    $('label[for="' + elemId + '"]').addClass('label-invalid');
}

function setInvalidStyleWithoutAlerts(form) {
    $(form).find('.k-invalid').each(function (i, val) {
        var elemId = $(val).attr('id');
        if ($(val).attr('data-role') === 'combobox') {
            $($(form).find('[name*="_input"]')).addClass('input-invalid');
        } else if ($(val).attr('data-role') === 'dropdownlist') {
            $(val).siblings('.k-dropdown-wrap').addClass('drop-invalid');
        } else if ($(val).attr('data-role') === 'multiselect') {
            $(val).siblings('.k-multiselect-wrap').addClass('multi-invalid');
        } else {
            $(val).addClass('input-invalid');
        }
        $('label[for="' + elemId + '"]').addClass('label-invalid');
    });
}

function removeInvalidStyle() {
    $('input, .k-dropdown-wrap,  [name*="_input"]').each(function (i, val) {
        var id = $(val).attr('id');
        $(val).removeClass('input-invalid drop-invalid');
        $('label[for="' + id + '"]').removeClass('label-invalid');
    })
}

function removeInvalidStyleElement(element) {
    var elemId = element.id;
    if (element.attr('data-role') === 'combobox') {
        $('[name="' + elemId + '_input"]').removeClass('input-invalid');
    } else if (element.attr('data-role') === 'dropdownlist') {
        element.siblings('.k-dropdown-wrap').removeClass('drop-invalid');
    } else {
        element.removeClass('input-invalid');
    }
    $('label[for="' + elemId + '"]').removeClass('label-invalid'); 
}

function removeInvalidStyleForm(form) {
    $(form).find('input, .k-dropdown-wrap, .k-multiselect-wrap, .k-textbox, [name*="_input"]').each(function (i, val) {
        var id = $(val).attr('id');
        $(val).removeClass('input-invalid drop-invalid k-invalid multi-invalid');
        $('label[for="' + id + '"]').removeClass('label-invalid');
    })

    $(form).find('.k-multiselect-wrap').each(function (i, val) {
        $(val).parent('.k-multiselect').siblings('label').removeClass('label-invalid');
    })
}

function validateForm(form, isHideAlerts) {
    let isValid;
    let validator;

    if (isHideAlerts) {
        validator = $(form).kendoValidator({
            errorTemplate: ""
        }).data("kendoValidator");
    } else {
        validator = $(form).kendoValidator().data("kendoValidator");
    }

    isValid = validator.validate();

    if (isHideAlerts) {
        hideAlerts();
    }

    return isValid;
}

//function checkComboBox(element) {
//    var elemId = $(element).attr('id');
//    if ($(element).kendoValidator().data("kendoValidator").validate()) {
//        $('[name="' + elemId + '_input"]').removeClass('input-invalid');
//        $('label[for="' + elemId + '"]').removeClass('label-invalid');
//    } else {
//        $('[name="' + elemId + '_input"]').addClass('input-invalid');
//        $('label[for="' + elemId + '"]').addClass('label-invalid');
//    }
//}

//function checkDropDown(element) {
//    var elemId = $(element).attr('id');
//    if ($(element).kendoValidator().data("kendoValidator").validate()) {
//        $(element).siblings('.k-dropdown-wrap').removeClass('drop-invalid');
//        $('label[for="' + elemId + '"]').removeClass('label-invalid');
//    } else {
//        $(element).siblings('.k-dropdown-wrap').addClass('drop-invalid');
//        $('label[for="' + elemId + '"]').addClass('label-invalid');
//    }
//}

//function checDatePickerValidation(input) {
//    var elemId = $(input).attr('id');
//    var validator = $(input).kendoValidator().data("kendoValidator");
//    if (validator.validate()) {
//        $(input).removeClass('input-invalid');
//        $('label[for="' + elemId + '"]').removeClass('label-invalid');
//    } else {
//        $(input).addClass('input-invalid');
//        $('label[for="' + elemId + '"]').addClass('label-invalid');
//    }
//}

function showWarningPopup(warningText) {
    $('#warningSummaryWindow').data('kendoWindow').center().open();
    $(".js-warning").html(warningText);
}

function checkForNullDropDown(val) {
    if (val === "") {
        showWarningPopup(dropDownWarning);
        return false;
    }
    return true;
}


const defaultGridValidatorOptions = {
    rules: {
        nonNullNumeric: (input) => {
            if (!!$(input).attr('required')) {
                let numeric = $(input).data('kendoNumericTextBox');
                if (!!numeric) {
                    if (numeric.value() != 0) {
                        return true;
                    }

                    return false;
                }
            }
            return true;
        }
    },
    messages: {
        nonNullNumeric: "Numbers must be non-zero",
    }
};


window.newPartyValidation = function newPartyValidation() {
    let isValid = validateForm($('#newParty'), true);

    if ($('#saveNewParty').length > 0) {
        if (isValid) {
            $('#saveNewParty').data('kendoButton').enable(true);
        } else {
            $('#saveNewParty').data('kendoButton').enable(false);
        }
    }
};

module.exports = {
    hideAlerts: hideAlerts,
    removeAlerts: removeAlerts,
    setInvalidStyle: setInvalidStyle,
    removeInvalidStyle: removeInvalidStyle,
    checkElement: checkElement,
    checkEmail: checkEmail,
    validateForm: validateForm,
    setInvalidStyleElement: setInvalidStyleElement,
    checkForNullDropDown: checkForNullDropDown,
    newPartyValidation: newPartyValidation,
    checkNumeric: checkNumeric,
    checkNumericNull: checkNumericNull,
    checkNumericNullCustom: checkNumericNullCustom,
    removeInvalidStyleElement: removeInvalidStyleElement,
    defaultGridValidatorOptions: defaultGridValidatorOptions,
};
